import { BRAND } from '@/lib/brand';

export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-100 focus:rounded-control focus:bg-surface focus:px-3 focus:py-2 focus:shadow-e1"
    >
      Skip to content
    </a>
  );
}

export function Disclaimer() {
  return (
    <footer className="border-t border-border bg-paper">
      <div className="mx-auto max-w-content px-4 py-3 sm:px-8">
        <p className="text-[11px] font-normal leading-snug text-muted">{BRAND.disclaimer}</p>
      </div>
    </footer>
  );
}
